/**
 * Recursively transforms form data by replacing empty strings with null.
 * Handles nested objects and arrays of objects.
 *
 * @param data - The input value or structure to transform
 * @returns A new structure with "" replaced by null at any depth
 */
export const transformFormData = <T>(data: T): T => {
    const transformRecursive = (value: unknown): unknown => {
        if (value === null) return null;
        if (value === undefined) return undefined;
        if (typeof value === 'string') {
            return value === '' ? null : value;
        }
        if (value instanceof File) {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(transformRecursive);
        }
        if (typeof value === 'object') {
            const transformedObject: Record<string, unknown> = {};
            for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
                transformedObject[key] = transformRecursive(val);
            }
            return transformedObject;
        }
        return value;
    };
    return transformRecursive(data) as T;
};
